import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _get from 'lodash/get';
import _isUndefined from 'lodash/isUndefined';
import { STATE_BY_MARKET_IDS } from '../constants/marketScan.constants'; // Do not return default values from getLoanTax, getLeaseTax, getCommonTaxRate

export var getLoanTax = function getLoanTax(taxAndZipCodeDetails) {
  return _get(taxAndZipCodeDetails, ['stateFeeTaxInfo', 'loanTax']);
};
export var getLeaseTax = function getLeaseTax(taxAndZipCodeDetails) {
  return _get(taxAndZipCodeDetails, ['stateFeeTaxInfo', 'leaseTax']);
};
export var getCommonTaxRate = function getCommonTaxRate(taxAndZipCodeDetails) {
  var commonTaxRate = _get(taxAndZipCodeDetails, 'taxRate');

  if (commonTaxRate === undefined || commonTaxRate === null) return commonTaxRate;
  return parseFloat(commonTaxRate);
};
export var getStateFeeTaxInfo = function getStateFeeTaxInfo(taxAndZipCodeDetails) {
  return _get(taxAndZipCodeDetails, ['stateFeeTaxInfo']);
};
export var getSecondTaxRate = function getSecondTaxRate(taxAndZipCodeDetails) {
  return _get(taxAndZipCodeDetails, ['secondTaxRate']);
};
export var getTaxMetadataForState = function getTaxMetadataForState(taxAndFeeMetaData, stateCode) {
  return ((taxAndFeeMetaData === null || taxAndFeeMetaData === void 0 ? void 0 : taxAndFeeMetaData.stateTaxConfig) || []).find(function (_ref) {
    var code = _ref.code;
    return code === (!_isUndefined(STATE_BY_MARKET_IDS[stateCode]) ? STATE_BY_MARKET_IDS[stateCode] : stateCode);
  });
};
export var getTaxOptionsForState = function getTaxOptionsForState(taxAndFeeMetaData, stateCode) {
  return _get(getTaxMetadataForState(taxAndFeeMetaData, stateCode), 'taxes') || [];
};
export var getTaxPctsForState = function getTaxPctsForState(taxAndFeeMetaData, stateCode) {
  return _get(getTaxMetadataForState(taxAndFeeMetaData, stateCode), 'taxPercentages') || [];
};
export var getFeeOptionsForState = function getFeeOptionsForState(taxAndFeeMetaData, stateCode) {
  return _get(getTaxMetadataForState(taxAndFeeMetaData, stateCode), 'fees') || [];
};
export var getNonUSZipTaxRates = function getNonUSZipTaxRates(zipTaxRates) {
  return zipTaxRates === null || zipTaxRates === void 0 ? void 0 : zipTaxRates.map(function (rates) {
    var regionName = rates.regionName,
        salesUseTaxPct = rates.salesUseTaxPct,
        taxes = rates.taxes;
    return {
      RegionName: regionName,
      StateFeeTax: _objectSpread(_objectSpread({}, taxes === null || taxes === void 0 ? void 0 : taxes.reduce(function (acc, tax) {
        var key = tax.key,
            value = tax.value;
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, value));
      }, {})), {}, {
        SalesUseTaxPct: salesUseTaxPct
      })
    };
  });
};

var formatTaxes = function formatTaxes() {
  var _taxRates;

  var taxes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var SalesUseTaxPct = _get(taxes.find(function (taxData) {
    return (taxData === null || taxData === void 0 ? void 0 : taxData.type) === 'TOTAL_TAX';
  }), 'value');

  var taxRates = taxes.filter(function (taxData) {
    return (taxData === null || taxData === void 0 ? void 0 : taxData.type) !== 'TOTAL_TAX';
  });
  taxRates = (_taxRates = taxRates) === null || _taxRates === void 0 ? void 0 : _taxRates.reduce(function (acc, tax) {
    var key = tax.key,
        value = tax.value;
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, value));
  }, {});
  return _objectSpread(_objectSpread({}, taxRates), {}, {
    SalesUseTaxPct: SalesUseTaxPct
  });
};

export var getZipTaxRates = function getZipTaxRates() {
  var zipTaxRates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var taxData = [];
  zipTaxRates.forEach(function (rates) {
    var _Retail, _Lease, _Retail2;

    var Retail = {};
    var Lease = {};
    var regionName = rates.regionName,
        locationKey = rates.locationKey,
        dealType = rates.dealType,
        taxes = rates.taxes,
        inCity = rates.inCity;
    var isTaxDataExistsForLocation = taxData.find(function (data) {
      return (data === null || data === void 0 ? void 0 : data.locationKey) === locationKey;
    });
    if (isTaxDataExistsForLocation) return;

    if (dealType === 'LOAN') {
      Retail = formatTaxes(taxes);
      var leaseTax = zipTaxRates.find(function (data) {
        return (data === null || data === void 0 ? void 0 : data.locationKey) === locationKey && (data === null || data === void 0 ? void 0 : data.dealType) === 'LEASE';
      });

      if (leaseTax) {
        Lease = formatTaxes(leaseTax === null || leaseTax === void 0 ? void 0 : leaseTax.taxes);
      }
    } else {
      Lease = formatTaxes(taxes);
      var loanTax = zipTaxRates.find(function (data) {
        return (data === null || data === void 0 ? void 0 : data.locationkey) === locationKey && (data === null || data === void 0 ? void 0 : data.dealType) === 'LOAN';
      });

      if (loanTax) {
        Retail = formatTaxes(loanTax === null || loanTax === void 0 ? void 0 : loanTax.taxes);
      }
    }

    taxData.push({
      RegionName: regionName,
      InCity: inCity,
      locationKey: locationKey,
      StateFeeTax: {
        Retail: Retail,
        Lease: Lease,
        SalesUseTaxPct: ((_Retail = Retail) === null || _Retail === void 0 ? void 0 : _Retail.SalesUseTaxPct) === ((_Lease = Lease) === null || _Lease === void 0 ? void 0 : _Lease.SalesUseTaxPct) ? (_Retail2 = Retail) === null || _Retail2 === void 0 ? void 0 : _Retail2.SalesUseTaxPct : null
      }
    });
  });
  return taxData;
};